import React from 'react';
import { connect } from 'react-redux';
import findResult from '@/utils/resultsHelper';
import { findWithUUID } from '@/utils/uuidHelper';
import { updateActiveDictionary } from '../actions';
import DictionaryDropdown from '../components/DictionaryDropdown';

const DictionaryChanger = ({
  category,
  code,
  dictionaries,
  uuid,
  updateDictionary,
  saveErrors,
}) => {
  if (dictionaries.length === 1) {
    return (<p className="aridhia-dictionary-dropdown-single" title={dictionaries[0].name}>{dictionaries[0].name}</p>);
  }

  let errors = [];
  if (saveErrors) {
    errors = saveErrors.map((error) => {
      if (error.context.entity === 'dictionary') {
        return findWithUUID(dictionaries, error.context.dictionaryUUID).name;
      }
      return null;
    });
  }

  return (
    <DictionaryDropdown
      dictionaries={dictionaries}
      value={uuid}
      errors={errors}
      inline
      onChange={(e, { value }) => updateDictionary(category, code, value)}
    />
  );
};

const mapStateToProps = ({
  datasets: {
    datasets,
  },
}, { category, code, saveErrors }) => {
  const dataset = findResult(datasets, category, code) || {
    saveErrors: [],
    dictionaries: [],
    activeDictionaryUUID: null,
    activeDictionaryName: '',
  };

  return (
    {
      saveErrors: saveErrors || dataset.saveErrors,
      dictionaries: dataset.dictionaries,
      uuid: dataset.activeDictionaryUUID,
      name: dataset.activeDictionaryName,
    }
  );
};

const mapDispatchToProps = {
  updateDictionary: updateActiveDictionary,
};

export default connect(mapStateToProps, mapDispatchToProps)(DictionaryChanger);
